import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';

export const DashboardPanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  return (
    <Panel {...panelProps}>
      <ul>
        <li>params: {JSON.stringify(params)}</li>
      </ul>
    </Panel>
  );
};
